<div class="self-checkout-footer-labels-container" [ngClass]="{ 'white-bg': isBgColorWhite }">
  <!-- <a href="https://takulabs.io/sign-up-today" target="_blank"> -->
  <div id="powered-by">
    <span class="text-sm mr-2">{{ appVersion }}</span>
    <span class="text">Powered by TAKU</span>
    <img src="/assets/layout/images/logo-loading.png" alt="TakuLabs" class="app-logo" />
  </div>
  <!-- </a> -->
</div>
